// Google Translate Integration for Shopify with Language Widget
// Basé sur le widget JM Legazel

(function() {
  // Configuration
  const CONFIG = {
    debugMode: false,                 // Activer/désactiver les logs de debug
    spanishEnabled: true,            // Activer/désactiver l'option espagnole
    widgetBackgroundColor: "#482c54", // Couleur de fond du widget
    widgetTextColor: "white",         // Couleur du texte du widget
    storageKey: "jml-preferred-language", // Clé pour le localStorage
    
    // Sélecteurs pour le contenu dynamique à observer
    dynamicContentSelectors: [
      '.product-recommendations', // Sélecteur commun pour les recommandations de produits
      '[data-section-type="product-recommendations"]', // Autre sélecteur possible
      '.related-products', // Autre sélecteur possible
      '.recommended-products', // Autre sélecteur possible
      // Ajoutez d'autres sélecteurs spécifiques à votre thème si nécessaire
    ],
    
    // Sélecteurs pour les éléments liés aux prix et aux devises
    currencyElements: [
      '.money',
      '.price',
      '.price-item',
      '.product-price',
      '.product__price',
      '.currency-converter-currency-button',
      '.cbb-desktop-view',
      '.cbb-currency-flag',
      '.cbb-currency-name',
      '.cbb-currency-picker-selected',
      '[data-currency-converter]',
      '[data-currency]'
    ],
    
    // Dictionnaire personnalisé pour les termes spécifiques
    customTranslations: {
      // FR -> EN
      // Termes à ne pas traduire (conserver le terme français)
      "carrosse": "carrosse",
      "Carrosse": "Carrosse",
      "CARROSSE": "CARROSSE",
      "READY-TO-WEAR":"READY-TO-WEAR",
      
      // Corrections de traductions
      "forme": "shape",
      "Forme": "Shape",
      "FORME": "SHAPE",
      "Entretien": "Shoecare",
      
      // Termes spécifiques
      "produit spécifique": "specific product",
      "Forme Carrosse": "Carrosse form",
      "Fins de séries": "Sales",
      "FINS DE SERIES": "SALES",
      "sur nos fins de séries": "See our Sales!",
      "Retour à Entretien": "Back to Shoecare",
      "Autres matières": "Other materials",
      
      // Protection des boutons de langue
      "EN": "EN",
      "FR": "FR",
      "ES": "ES"
    },
    
    // Traductions espagnoles (si activées)
    spanishTranslations: {
      "carrosse": "carrosse",
      "Carrosse": "Carrosse",
      "Anglaise": "Anglaise",
      "Forme Anglaise": "Forma Anglaise",
      "Forme Carrosse": "Forma Carrosse",
      "Forme Italienne": "Forma Italienne",
      "Forme Française": "Forma Française",
      "FINS DE SERIES": "PROMOCIONES",
      "forme": "forma",
      "Forme": "Forma",
      "sneakers": "sneakers",
      "Sneakers": "Sneakers",
      "SNEAKERS": "SNEAKERS",
      "Chaussettes": "Calcetines",
      "CHAUSSETTES":"CALCETINES",
      "TAILLE": "TALLA",
      "Taille": "Talla",
      "taille": "talla",
      "SAPHIR": "SAPHIR",
      "Saphir": "Saphir",
      "Crème Saphir": "Crema Saphir",
      "terme technique": "término técnico",
      "produit spécifique": "producto específico",
      "Choisissez votre taille": "Elige tu talla",
      "Vernis":"Charol",
      "VERNIS":"CHAROL",
      "vernis": "charol",
      "FR07 - VERNIS BICOLORE": "FR07 - BICOLOR CHAROL",
      "- VERNIS BICOLORE": "- BICOLOR CHAROL",
      "READY-TO-WEAR":"READY-TO-WEAR",
      "sur nos fins de séries": "en nuestras promociones",
      "Training": "Sneakers de training",
      "Comfort":"Comfort",
      "Comfort 01": "Comfort 01",
      "COMFORT 01": "COMFORT 01",
      "TR360 Training": "TR360 Training",
      "TR02 Training": "TR02 Training",
      "TR180 Training": "TR180 Training",
      "SN04 SNEAKERS":"SN04 SNEAKERS",
      "SN05 SNEAKERS":"SN05 SNEAKERS",
      "SN01 SNEAKERS":"SN01 SNEAKERS",
      "SN02 SNEAKERS":"SN02 SNEAKERS",
      "SN03 SNEAKERS PLASTRON CROCODILE":"SN03 Sneakers PLASTRÓN COCODRILO",
      "Retour à Sneakers": "VOLVER A SNEAKERS",
      "Retour à Forme CARROSSE": "VOLVER A FORMA CARROSSE",
      "Retour à Entretien":"Volver a Cuidado del calzado",
      "EN08 SLIPPERS VERNIS NOIR": "EN08 SLIPPERS CHAROL NEGRO",
      "FR07 Vernis Bicolore": "FR07 charol bicolor",
      "IT01 Vernis noir": "IT01 Charol Negro",
      "IT07 Vernis Blanc avec Plastron Vernis Noir": "IT07 Charol blanco con placa frontal de charol negro",
      "IT07 Vernis Noir avec Plastron Vernis Blanc":"IT07 Charol negro con placa frontal de charol blanco",
      "Entretien":"Cuidado del calzado",
      "EX10 READY-TO-WEAR":"EX10 READY-TO-WEAR",  "EX08 READY-TO-WEAR":"EX08 READY-TO-WEAR",
      "EN16 READY-TO-WEAR":"EN16 READY-TO-WEAR",  "IT16 READY-TO-WEAR":"IT16 READY-TO-WEAR",
      "EX09 READY-TO-WEAR":"EX09 READY-TO-WEAR",  "EN17 READY-TO-WEAR":"EN17 READY-TO-WEAR",
      "EN18 READY-TO-WEAR":"EN18 READY-TO-WEAR",  "EN19 READY-TO-WEAR":"EN19 READY-TO-WEAR",
      "EN20 READY-TO-WEAR":"EN20 READY-TO-WEAR",
      "100 POINTS" : "100 PUNTOS",
      "100 Points" : "100 Puntos",
      "Point" : "Punto",
      "point" : "punto",
      "Points" : "Puntos",
      "POINTS" : "PUNTOS",
      "Autres matières": "Otros materiales",
      "sur commande" : "por encargo",
      "Bring our brand to life" : "Bring our brand to life",
      "BRING OUR BRAND TO LIFE" : "BRING OUR BRAND TO LIFE",
      "workshop@jmlegazel.com" : "workshop@jmlegazel.com",
         
      // Ajout pour préserver les devises
      "EUR": "EUR",
      "USD": "USD",
      "GBP": "GBP",
      "CAD": "CAD",
      "AUD": "AUD",
      "JPY": "JPY",
      "CHF": "CHF",
      "CNY": "CNY",
      "HKD": "HKD",
      "ZAR": "ZAR",
      
      // Protection des noms de devises
      "Euro": "Euro",
      "euros": "euros",
      "Dollar américain": "Dólar estadounidense",
      "Dollar canadien": "Dólar canadiense",
      "Dollar australien": "Dólar australiano",
      "Livre sterling": "Libra esterlina",
      "Yen japonais": "Yen japonés",
      "Yuan chinois": "Yuan chino",
      "Dollar de Hong Kong": "Dólar de Hong Kong",
      "Rand sud-africain": "Rand sudafricano",
      
      // Protection des boutons de langue et tailles
      "EN": "EN",
      "FR": "FR",
      "ES": "ES",
      "EU: 39 / UK: 5 / US: 6": "UE: 39 / UK: 5 / US: 6",
      "EU: 39.5 / UK: 5.5 / US: 6.5": "UE: 39.5 / UK: 5.5 / US: 6.5",
      "EU: 40 / UK: 6 / US: 7": "UE: 40 / UK: 6 / US: 7",
      "EU: 40.5 / UK: 6.5 / US: 7.5": "UE: 40.5 / UK: 6.5 / US: 7.5",
      "EU: 41 / UK: 7 / US: 8": "UE: 41 / UK: 7 / US: 8",
      "EU: 41.5 / UK: 7.5 / US: 8.5": "EU: 41.5 / UK: 7.5 / US: 8.5",
      "EU: 42 / UK: 8 / US: 9": "EU: 42 / UK: 8 / US: 9",
      "EU: 42.5 / UK: 8.5 / US: 9.5":"UE: 42.5 / UK: 8.5 / US: 9.5",
      "EU: 43 / UK: 9 / US: 10":"UE: 43 / UK: 9 / US: 10",
      "EU: 43.5 / UK: 9.5 / US: 10.5":"UE: 43.5 / UK: 9.5 / US: 10.5",
      "EU: 44 / UK: 10 / US: 11":"UE: 44 / UK: 10 / US: 11",
      "EU: 44.5 / UK: 10.5 / US: 11.5":"UE: 44.5 / UK: 10.5 / US: 11.5",
      "EU: 45 / UK: 11 / US: 12":"UE: 45 / UK: 11 / US: 12",
      "EU: 45.5 / UK: 11.5 / US: 12.5":"UE: 45.5 / UK: 11.5 / US: 12.5",
      "EU: 46 / UK: 12 / US: 13":"UE: 46 / UK: 12 / US: 13",
      "EU: 46.5 / UK: 12.5 / US: 13.5":"UE: 46.5 / UK: 12.5 / US: 13.5",
      "EU: 47 / UK: 13 / US: 14":"UE: 47 / UK: 13 / US: 14"
    }
  };

  // Variable pour stocker l'observateur
  let dynamicContentObserver = null;
  
  // Variable pour suivre la langue actuelle
  let currentLanguage = 'fr';

  // Fonction pour activer la conversion des devises en espagnol
  function enableCurrencyConversionForSpanish() {
    if (CONFIG.debugMode) {
      console.log('Activation de la conversion de devises pour l\'espagnol');
    }
    
    // Supprimer les attributs qui empêchent la traduction/conversion
    CONFIG.currencyElements.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      if (elements.length && CONFIG.debugMode) {
        console.log(`Éléments monétaires trouvés (${selector}):`, elements.length);
      }
      
      elements.forEach(element => {
        // Permettre au convertisseur de devises de fonctionner
        element.removeAttribute('data-notranslate');
        element.removeAttribute('translate');
        element.classList.remove('jml-no-translate');
      });
    });
    
    // Essayer de réactiver le convertisseur s'il existe
    if (typeof window.DoublyGlobalCurrency !== 'undefined') {
      try {
        window.DoublyGlobalCurrency.convertAll();
        if (CONFIG.debugMode) {
          console.log('Conversion de devise réactivée pour l\'espagnol');
        }
      } catch(e) {
        console.error('Erreur lors de la réactivation de la conversion:', e);
      }
    }
    
    // Pour d'autres convertisseurs comme Bold Currency
    if (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined') {
      try {
        if (typeof window.BOLD.common.eventEmitter !== 'undefined') {
          window.BOLD.common.eventEmitter.emit('BOLD_CURRENCY_refresh');
        }
        if (CONFIG.debugMode) {
          console.log('Émission événement Bold Currency refresh');
        }
      } catch(e) {
        console.error('Erreur avec Bold Currency:', e);
      }
    }
  }

  // Fonction pour traduire le texte avec l'API Google et appliquer les traductions personnalisées
  function translatePage(targetLanguage) {
    // Ne traduire que si la page n'est pas déjà dans la langue cible
    if (document.documentElement.lang !== targetLanguage) {
      // Mettre à jour la langue actuelle
      currentLanguage = targetLanguage;
      
      // Enregistrer la préférence de langue
      localStorage.setItem(CONFIG.storageKey, targetLanguage);
      
      // Mettre à jour l'apparence du widget
      updateWidgetState(targetLanguage);
      
      // Traduire le contenu de la page
      translateContent(document.body, targetLanguage);
      
      // Changer la langue de la page
      document.documentElement.lang = targetLanguage;
      
      // Observer le contenu dynamique
      setupDynamicContentObserver(targetLanguage);
      
      // Si la langue est l'espagnol, activer spécifiquement la conversion de devises après un délai
      if (targetLanguage === 'es') {
        setTimeout(enableCurrencyConversionForSpanish, 1000);
        setTimeout(enableCurrencyConversionForSpanish, 2000);
      }
    }

    // Fonction pour cibler spécifiquement les éléments dynamiques de Shopify
    function translateShopifyDynamicElements(targetLanguage) {
      // Liste des sélecteurs pour les éléments dynamiques courants de Shopify
      const dynamicShopifySelectors = [
        // Titres de produits
        '.product-single__title',
        '.product__title',
        '.product-title',
        'h1.title',
        
        // Descriptions
        '.product-single__description',
        '.product__description',
        '.product-description',
        
        // Variantes et options
        '.single-option-selector__label',
        '.variant-input-wrap label',
        '.product-form__item label',
        
        // Sections spécifiques
        '[data-section-type="product-template"]',
        '[data-section-type="collection-template"] .section-header h1',
        '[data-section-type="featured-collection"] .section-header h2',
        
        // Métachamps (souvent chargés dynamiquement)
        '[data-product-metafield]',
        '.product-metafield',
        '.product-single__meta-list',
        
        // Ajoutez d'autres sélecteurs spécifiques à votre thème ici
      ];
      
      // Parcourir tous les sélecteurs et traduire les éléments correspondants
      dynamicShopifySelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        
        if (elements.length && CONFIG.debugMode) {
          console.log(`Éléments Shopify dynamiques trouvés (${selector}):`, elements.length);
        }
        
        elements.forEach(element => {
          // Vérifier si l'élément n'est pas déjà protégé contre la traduction
          if (!element.hasAttribute('data-notranslate')) {
            translateContent(element, targetLanguage);
          }
        });
      });
    }


    // Après la traduction initiale, effectuer des passes supplémentaires pour les éléments dynamiques
    setTimeout(function() {
      translateShopifyDynamicElements(targetLanguage);
    }, 1000);

    setTimeout(function() {
      translateShopifyDynamicElements(targetLanguage);
    }, 2500);
  }
  
  // Fonction pour traduire un élément spécifique et ses descendants
  function translateContent(element, targetLanguage) {
    if (!element) return;
    
    // Si nous traduisons en espagnol, appliquer des protections spécifiques
    if (targetLanguage === 'es') {
      // L'espagnol a besoin de protections spécifiques pour le convertisseur
      const currencyElements = element.querySelectorAll(CONFIG.currencyElements.join(', '));
      if (currencyElements.length && CONFIG.debugMode) {
        console.log('Protection initiale des éléments de devise pour l\'espagnol:', currencyElements.length);
      }
    }
    
    // Récupérer tous les éléments de texte visibles
    const textNodes = getAllTextNodes(element);

    // Choix du dictionnaire en fonction de la langue cible
    const translations = targetLanguage === 'es' ? 
      CONFIG.spanishTranslations : CONFIG.customTranslations;

    // Traiter chaque nœud de texte
    textNodes.forEach(node => {
      let text = node.textContent.trim();
      
      // Vérifier si le nœud est dans un élément monétaire pour l'espagnol
      if (targetLanguage === 'es' && 
          (node.parentNode.closest('.currency-converter') || 
           node.parentNode.closest('[data-currency]') ||
           node.parentNode.closest('.money'))) {
        // Ignorer les nœuds de texte liés aux devises pour l'espagnol
        return;
      }
      
      // Vérifier d'abord si le texte est dans notre dictionnaire personnalisé
      if (translations[text] !== undefined) {
        node.textContent = node.textContent.replace(
          text, 
          translations[text]
        );
      } 
      // Sinon, utiliser l'API Google Translate
      else if (text.length > 0) {
        translateText(text, targetLanguage).then(translatedText => {
          // S'assurer que le nœud existe toujours (il pourrait avoir été supprimé)
          if (node.parentNode) {
            // Remplacer le texte original par la traduction
            node.textContent = node.textContent.replace(text, translatedText);
          }
        });
      }
    });
  }

  // Fonction pour obtenir tous les nœuds de texte d'un élément
  function getAllTextNodes(element) {
    if (!element) return [];
    
    const textNodes = [];
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          // Ignorer les scripts, styles, etc.
          if (node.parentNode.tagName === 'SCRIPT' || 
              node.parentNode.tagName === 'STYLE' ||
              node.parentNode.tagName === 'NOSCRIPT') {
            return NodeFilter.FILTER_REJECT;
          }
          
          // Ignorer les textes vides ou seulement des espaces
          if (node.textContent.trim() === '') {
            return NodeFilter.FILTER_REJECT;
          }
          
          // Ignorer les nœuds texte à l'intérieur du widget de langue
          if (node.parentNode.closest('.jml-language-widget')) {
            return NodeFilter.FILTER_REJECT;
          }
          
          // Pour l'espagnol, on ignore aussi les éléments du convertisseur de devises
          if (currentLanguage === 'es' && 
              (node.parentNode.closest('.currency-converter') ||
               node.parentNode.closest('.currency-converter-currency-button') ||
               node.parentNode.closest('.cbb-desktop-view') ||
               node.parentNode.closest('.cbb-currency-flag'))) {
            return NodeFilter.FILTER_REJECT;
          }
          
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }
    
    return textNodes;
  }

  // Fonction pour revenir au français
  function switchToFrench() {
    currentLanguage = 'fr';
    localStorage.setItem(CONFIG.storageKey, 'fr');
    updateWidgetState('fr');
    
    // Désactiver l'observateur de contenu dynamique
    if (dynamicContentObserver) {
      dynamicContentObserver.disconnect();
      dynamicContentObserver = null;
    }
    
    // Recharger la page pour revenir à la version française originale
    window.location.reload();
  }
  
  // Mettre à jour l'apparence du widget selon l'état
// Mettre à jour l'apparence du widget selon l'état
function updateWidgetState(lang) {
  const buttons = document.querySelectorAll('.jml-language-btn');
  if (buttons.length) {
    buttons.forEach(button => {
      // Enlever la classe active de tous les boutons
      button.classList.remove('active');
      // Ajouter la classe active au bouton correspondant à la langue actuelle
      if (button.getAttribute('data-lang') === lang) {
        button.classList.add('active');
      }
    });
  }
  
  // Mettre à jour également le texte du bouton principal
  const mainButton = document.querySelector('.jml-language-main-btn');
  if (mainButton) {
    mainButton.innerHTML = `<span>${lang.toUpperCase()}</span><span class="dropdown-arrow">▼</span>`;
  }
}  
  // Fonction pour appeler l'API Google Translate
  async function translateText(text, targetLanguage) {
    // Clé API de Google Translate (vous devez obtenir la vôtre)
    const apiKey = 'AIzaSyBlAS_9IvEJeCs_e0KiHc0GXJ42o13WEzE';
    
    try {
      const response = await fetch(
        `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            q: text,
            source: 'fr',
            target: targetLanguage,
            format: 'text'
          })
        }
      );
      
      const data = await response.json();
      
      if (data.data && data.data.translations && data.data.translations.length > 0) {
        return data.data.translations[0].translatedText;
      }
      
      return text; // En cas d'erreur, retourner le texte original
    } catch (error) {
      console.error('Erreur de traduction:', error);
      return text; // En cas d'erreur, retourner le texte original
    }
  }

  // Fonction pour configurer l'observateur de contenu dynamique
  function setupDynamicContentObserver(targetLanguage) {
    // Désactiver l'observateur existant s'il y en a un
    if (dynamicContentObserver) {
      dynamicContentObserver.disconnect();
    }
    
    // Ne configurer l'observateur que si nous ne sommes pas en français
    if (targetLanguage === 'fr') return;
    
    // Créer un nouvel observateur
    dynamicContentObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Vérifier les nouveaux nœuds ajoutés
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            // Vérifier si c'est un élément DOM
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Vérifier si cet élément ou l'un de ses parents correspond à nos sélecteurs
              const isDynamicContent = CONFIG.dynamicContentSelectors.some(selector => {
                return node.matches(selector) || node.querySelector(selector);
              });
              
              if (isDynamicContent || isProductElement(node)) {
                if (CONFIG.debugMode) {
                  console.log('Contenu dynamique détecté:', node);
                }
                
                // Attendre un peu que le contenu soit complètement chargé
                setTimeout(function() {
                  translateContent(node, currentLanguage);
                  
                  // Pour l'espagnol, réactiver la conversion de devises si nécessaire
                  if (currentLanguage === 'es') {
                    setTimeout(enableCurrencyConversionForSpanish, 300);
                  }
                }, 500);
              }
            }
          });
        }
      });
    });
    
    // Observer les changements dans le document
    dynamicContentObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Observer spécifiquement les conteneurs de recommandations de produits
    CONFIG.dynamicContentSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        dynamicContentObserver.observe(element, {
          childList: true,
          subtree: true
        });
      });
    });
  }
  
  // Fonction pour vérifier si un élément est lié à un produit
  function isProductElement(element) {
    // Vérifier les classes et attributs communs des éléments de produit
    return element.classList.contains('product') || 
           element.classList.contains('product-card') ||
           element.hasAttribute('data-product-id') ||
           element.querySelector('.product-title') ||
           element.querySelector('.product-price');
  }
  
  // Fonction spécifique pour observer les événements du convertisseur de devises
  function setupCurrencyConverterObserver() {
    // Observer les clics sur les boutons de devise
    document.addEventListener('click', function(event) {
      // Vérifier si le clic est sur un élément du convertisseur
      if (event.target.closest('.currency-converter-currency-button, .cbb-currency-flag, .cbb-currency-name')) {
        if (CONFIG.debugMode) {
          console.log('Clic sur un élément du convertisseur de devises détecté');
        }
        
        // Si nous sommes en espagnol, réactiver la conversion de devises
        if (currentLanguage === 'es') {
          setTimeout(enableCurrencyConversionForSpanish, 300);
        }
      }
    });
    
    // Observer les événements spécifiques au convertisseur
    document.addEventListener('currency:change', function() {
      if (CONFIG.debugMode) {
        console.log('Événement currency:change détecté');
      }
      
      if (currentLanguage === 'es') {
        setTimeout(enableCurrencyConversionForSpanish, 300);
      }
    });
    
    // Pour Bold Currency Converter
    if (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined') {
      document.addEventListener('BOLD_CURRENCY_SWITCHED', function() {
        if (CONFIG.debugMode) {
          console.log('Événement BOLD_CURRENCY_SWITCHED détecté');
        }
        
        if (currentLanguage === 'es') {
          setTimeout(enableCurrencyConversionForSpanish, 300);
        }
      });
    }
  }

  // Fonction pour créer le widget de langue
function createLanguageWidget() {
  // Vérifier si le widget existe déjà
  if (document.querySelector('.jml-language-widget')) {
    document.querySelector('.jml-language-widget').remove();
  }

  // Créer le widget
  const widget = document.createElement("div");
  widget.className = "jml-language-widget";
  
  // Récupérer la langue actuelle
  const savedLang = localStorage.getItem(CONFIG.storageKey) || "fr";
  
  // Créer le bouton principal qui affiche la langue actuelle avec une flèche
  let buttonHTML = `
    <div class="language-toggle">
      <button class="jml-language-main-btn">
        <span>${savedLang.toUpperCase()}</span>
        <span class="dropdown-arrow">▼</span>
      </button>
      <div class="language-dropdown">
        <button class="jml-language-btn" data-lang="fr">FR</button>
        <button class="jml-language-btn" data-lang="en">EN</button>
  `;
  
  // Ajouter le bouton Espagnol si activé
  if (CONFIG.spanishEnabled) {
    buttonHTML += `<button class="jml-language-btn" data-lang="es">ES</button>`;
  }
  
  buttonHTML += `</div></div>`;
  widget.innerHTML = buttonHTML;

  // Appliquer du style CSS au widget
  const style = document.createElement("style");
  style.textContent = `
    .jml-language-widget {
      position: fixed;
      top: 10px;
      right: 20px;
      z-index: 999;
      font-size: 16px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      border-radius: 4px;
      background: ${CONFIG.widgetBackgroundColor};
    }
    .jml-language-widget .language-toggle {
      position: relative;
      display: flex;
      flex-direction: column;
    }
    .jml-language-widget .jml-language-main-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px;
      border: none;
      background: transparent;
      color: ${CONFIG.widgetTextColor};
      cursor: pointer;
      font-weight: bold;
      transition: all 0.3s ease;
      font-size: 16px;
      min-width: 70px;
    }
    .jml-language-widget .dropdown-arrow {
      margin-left: 8px;
      font-size: 10px;
      transition: transform 0.3s;
    }
    .jml-language-widget:hover .dropdown-arrow {
      transform: rotate(180deg);
    }
    .jml-language-widget .language-dropdown {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      flex-direction: column;
      background: ${CONFIG.widgetBackgroundColor};
      border-radius: 0 0 4px 4px;
      overflow: hidden;
      box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    }
    .jml-language-widget:hover .language-dropdown {
      display: flex;
    }
    .jml-language-widget .jml-language-btn {
      padding: 8px 12px;
      border: none;
      background: transparent;
      color: ${CONFIG.widgetTextColor};
      cursor: pointer;
      font-weight: bold;
      transition: all 0.3s ease;
      font-size: 16px;
      text-align: center;
      width: 100%;
    }
    .jml-language-widget .jml-language-btn.active {
      background: rgba(255, 255, 255, 0.2);
    }
    .jml-language-widget .jml-language-btn:hover:not(.active) {
      background: rgba(255, 255, 255, 0.1);
    }
    
    @media (max-width: 768px) {
      .jml-language-widget {
        right: 10px;
      }
    }
  `;

  // Ajouter les styles à la page
  document.head.appendChild(style);

  // Ajouter le widget au body
  document.body.appendChild(widget);

  // Ajouter les événements de clic sur les boutons
  const buttons = widget.querySelectorAll(".jml-language-btn");
  buttons.forEach(button => {
    button.addEventListener("click", function() {
      const lang = this.getAttribute("data-lang");
      
      // Mettre à jour l'apparence du widget AVANT l'action
      buttons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      
      // Mettre à jour le texte du bouton principal
      const mainButton = widget.querySelector('.jml-language-main-btn');
      mainButton.innerHTML = `<span>${lang.toUpperCase()}</span><span class="dropdown-arrow">▼</span>`;
      
      // Si on n'est pas déjà en français et qu'on veut une autre langue que le français,
      // on force d'abord un retour au français
      if (currentLanguage !== 'fr' && lang !== 'fr') {
        // Enregistrer la langue cible pour après le rechargement
        localStorage.setItem('jml-next-language', lang);
        
        // Forcer le retour au français (cela va recharger la page)
        switchToFrench();
        
        // Ne pas continuer l'exécution
        return;
      }
      
      // Comportement normal
      if (lang === 'fr') {
        switchToFrench();
      } else {
        translatePage(lang);
      }
    });
  });

  // Mettre à jour l'état initial du widget en fonction de la langue actuelle
  updateWidgetState(savedLang);
}

// Fonction pour rechercher et traduire manuellement les sections de recommandations
function translateRecommendations(targetLanguage) {
  CONFIG.dynamicContentSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    if (elements.length && CONFIG.debugMode) {
      console.log(`Sections de recommandations trouvées (${selector}):`, elements.length);
    }
    
    elements.forEach(element => {
      translateContent(element, targetLanguage);
    });
  });
  
  // Pour l'espagnol, réactiver la conversion de devises après traduction des recommandations
  if (targetLanguage === 'es') {
    setTimeout(enableCurrencyConversionForSpanish, 500);
  }
}

  // Initialisation
  document.addEventListener('DOMContentLoaded', function() {
    // Créer le widget de langue
    createLanguageWidget();
    
    // Vérifier s'il y a une langue "suivante" à appliquer (après un retour au français)
    const nextLanguage = localStorage.getItem('jml-next-language');
    if (nextLanguage && nextLanguage !== 'fr') {
      // Supprimer cette information pour éviter des boucles
      localStorage.removeItem('jml-next-language');
      
      // Appliquer la traduction après un court délai
      setTimeout(function() {
        translatePage(nextLanguage);
        updateWidgetState(nextLanguage);
        
        // Pour l'espagnol, activer la conversion de devises
        if (nextLanguage === 'es') {
          setTimeout(enableCurrencyConversionForSpanish, 1000);
          setTimeout(enableCurrencyConversionForSpanish, 2000);
        }
      }, 500);
    } 
    // Sinon, vérifier s'il y a une préférence de langue enregistrée
    else {
      const preferredLanguage = localStorage.getItem(CONFIG.storageKey);
      
      if (preferredLanguage && preferredLanguage !== 'fr') {
        // Traduire la page dans la langue préférée
        translatePage(preferredLanguage);
        
        // Essayer de trouver et traduire les recommandations après un court délai
        setTimeout(function() {
          translateRecommendations(preferredLanguage);
          
          // Pour l'espagnol, activer la conversion de devises
          if (preferredLanguage === 'es') {
            setTimeout(enableCurrencyConversionForSpanish, 1500);
            setTimeout(enableCurrencyConversionForSpanish, 2500);
          }
        }, 1500);
      }
    }
    
    // Initialiser l'observateur du convertisseur de devises
    setupCurrencyConverterObserver();
  });

  // Exposer quelques fonctions à la console pour le débogage
  window.jmlTranslator = {
    translate: translatePage,
    translateElement: translateContent,
    translateRecommendations: function() {
      return translateRecommendations(currentLanguage);
    },
    setSpanishEnabled: function(enabled) {
      CONFIG.spanishEnabled = enabled;
      createLanguageWidget();
      return `Option espagnole ${enabled ? 'activée' : 'désactivée'}`;
    },
    addCustomTranslation: function(french, english, spanish) {
      CONFIG.customTranslations[french] = english;
      if (spanish) {
        CONFIG.spanishTranslations[french] = spanish;
      }
      return `Traduction personnalisée ajoutée: "${french}" -> EN:"${english}"${spanish ? `, ES:"${spanish}"` : ''}`;
    },
    setDebugMode: function(enabled) {
      CONFIG.debugMode = enabled;
      return `Mode débogage ${enabled ? 'activé' : 'désactivé'}`;
    },
    addDynamicSelector: function(selector) {
      if (!CONFIG.dynamicContentSelectors.includes(selector)) {
        CONFIG.dynamicContentSelectors.push(selector);
        setupDynamicContentObserver(currentLanguage);
        return `Sélecteur ajouté: "${selector}"`;
      }
      return `Le sélecteur "${selector}" existe déjà`;
    },
    // Ajout d'une fonction pour activer manuellement la conversion de devises en espagnol
    enableSpanishCurrencyConversion: function() {
      if (currentLanguage === 'es') {
        enableCurrencyConversionForSpanish();
        return "Conversion de devises pour l'espagnol activée manuellement";
      }
      return "Cette fonction ne fonctionne qu'en mode espagnol";
    }
  };
})();
